import script from "./_id.vue?vue&type=script&setup=true&lang=js"
export * from "./_id.vue?vue&type=script&setup=true&lang=js"

import "./_id.vue?vue&type=style&index=0&id=68a28f9d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68a28f9d"]])

export default __exports__